import { RiPaletteLine, RiStackLine } from "@remixicon/react";
import {
  Command,
  LayoutDashboard,
  MessageSquareText,
  Newspaper,
  Printer,
  ReceiptText,
  Share2,
  ShieldCheck,
  Tags,
  UserCog,
  Users,
  Video,
} from "lucide-react";
import type { SidebarData } from "../types";

export const sidebarData: SidebarData = {
  teams: [
    {
      name: "Life Football CF",
      logo: Command,
      plan: "ລະບົບ CF",
    },
  ],
  navGroups: [
    {
      title: "ທົ່ວໄປ",
      items: [
        {
          title: "ຕັ້ງຄ່າ Widget OBS",
          url: "/app/widget-settings",
          icon: RiPaletteLine,
          requiredPermissions: ["live:read"],
        },
        {
          title: "ແຜງຄວບຄຸມ",
          url: "/app/dashboard",
          icon: LayoutDashboard,
          requiredPermissions: ["dashboard:read"],
        },
        {
          title: "Facebook",
          url: "/app/facebook",
          icon: Share2,
          requiredPermissions: ["facebook:read"],
        },
        {
          title: "ຈັດການຫນ້າຟີດ",
          url: "/app/feeds",
          icon: Newspaper,
          requiredPermissions: ["feeds:read"],
        },
        {
          title: "Live",
          url: "/app/live",
          icon: Video,
          requiredPermissions: ["live:read"],
        },
        {
          title: "ຊຸດສິນຄ້າ",
          url: "/app/product-sets",
          icon: RiStackLine,
          requiredPermissions: ["live:read"],
        },
        {
          title: "ສ້າງສິນຄ້າໃນໂພສ",
          url: "/app/feeds/post-products",
          icon: Newspaper,
          requiredPermissions: ["products:manage"],
        },
        {
          title: "ລະຫັດ CF ສິນຄ້າ",
          url: "/app/product-default-codes",
          icon: Tags,
          requiredPermissions: ["products:manage"],
        },
        {
          title: "ຄ່າພິມຊື່ / ໝາຍເລກ",
          url: "/app/print-fee-settings",
          icon: Printer,
          requiredPermissions: ["products:manage"],
        },
        {
          title: "ຕິດຕາມອໍເດີ",
          url: "/app/orders",
          icon: ReceiptText,
          requiredPermissions: ["orders:read"],
        },
        {
          title: "ການຕັ້ງຄ່າຂໍ້ຄວາມ",
          url: "/app/message-templates",
          icon: MessageSquareText,
          requiredPermissions: ["messages:read"],
        },
      ],
    },
    {
      title: "ການຄວບຄຸມການເຂົ້າເຖິງ",
      items: [
        {
          title: "ບົດບາດ",
          url: "/app/roles",
          icon: UserCog,
          requiredPermissions: ["users:read"],
        },
        {
          title: "ຜູ້ໃຊ້",
          url: "/app/users",
          icon: Users,
          requiredPermissions: ["users:read"],
        },
        {
          title: "ບັນທຶກການກວດກາ",
          url: "/app/audit",
          icon: ShieldCheck,
          requiredPermissions: ["audit:read"],
        },
      ],
    },
  ],
};
